/** AutoMapa dealer portal lives under the automap Client View namespace. */
export const AUTOMAP_DEALER_PORTAL_BASE = "/v/automap/dealer";

export function automapDealerPortalPath(segment = "") {
  const normalized = String(segment || "").replace(/^\/+/, "");
  return normalized ? `${AUTOMAP_DEALER_PORTAL_BASE}/${normalized}` : AUTOMAP_DEALER_PORTAL_BASE;
}
